import validate from './validate'

var isMobile = (rule, value, callback) => {
  if (value && !validate.isMobile(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}

var isMobileCode = (rule, value, callback) => {
  if (value && !validate.isMobileCode(value)) {
    callback(new Error('请输入正确的验证码'))
  } else {
    callback()
  }
}

var isPhone = (rule, value, callback) => {
  if (value && !validate.isPhone(value)) {
    callback(new Error('请输入正确的电话'))
  } else {
    callback()
  }
}

var isPwd = (rule, value, callback) => {
  if (value && !validate.isPwd(value)) {
    callback(new Error('密码由8~16位数字、特殊字符、大写字母、小写字母组合'))
  } else {
    callback()
  }
}

var isEmail = (rule, value, callback) => {
  if (value && !validate.isEmail(value)) {
    callback(new Error('请输入有效的邮箱'))
  } else {
    callback()
  }
}

var isURL = (rule, value, callback) => {
  if (value && !validate.isURL(value)) {
    callback(new Error('请输入有效的URL'))
  } else {
    callback()
  }
}

var isDigits = (rule, value, callback) => {
  if (value && !validate.isDigits(value)) {
    callback(new Error('只能输入数字'))
  } else {
    callback()
  }
}

var isChinese = (rule, value, callback) => {
  if (value && !validate.isChinese(value)) {
    callback(new Error('只能输入中文'))
  } else {
    callback()
  }
}

var isPrice = (rule, value, callback) => {
  if (value && !validate.isPrice(value)) {
    callback(new Error('请输入正确的价格'))
  } else {
    callback()
  }
}

var isEmoji = (rule, value, callback) => {
  if (value && validate.isEmoji(value)) {
    callback(new Error('请勿输入特殊字符'))
  } else {
    callback()
  }
}

var numLimit = (rule, value, callback) => {
  if (value && !validate.numLimit(value)) {
    callback(new Error('请输入正确的数量'))
  } else {
    callback()
  }
}

// 数据规则校验
// [{ required: item.basicRequired == '0' ? true: false, message: '必填项不能为空', trigger: 'change' }]
var dataRule = (data) => {
  console.log(data);
  return [{
    required: data.basicRequired == '0' ? true: false,
    validator: (rule, value, callback) => {
      console.log(!value);
      if(data.basicRequired == '0' && !value) {
        callback(new Error('必填项不能为空'))
      }
      /*if(!data.metadataBasicDataRuleVo) {
        return
      }
      let {ruleMax, ruleMin} = data.metadataBasicDataRuleVo
      if ((data.basicAssemblyId == 1 || data.basicAssemblyId == 2) && value && value.length > ruleMax || value.length < ruleMin) {
        let str = ''
        if(ruleMin) {
          str = '-'
        }
        callback(new Error('字符数量限制'+ ruleMin + str + ruleMax+'个字'));
      }*/
      callback();
    }, trigger: 'change'
  }]
}


export default {dataRule, numLimit, isEmoji, isPrice, isURL, isEmail, isMobile, isPhone, isPwd, isMobileCode, isDigits, isChinese}
